import { JSX, ParentProps } from 'solid-js'
import styles from './st-grid-layout.module.css'

export class GridLayoutProps {
    columns: number = 1
}

export default function GridLayout(props: ParentProps<GridLayoutProps> & JSX.HTMLAttributes<HTMLDivElement>) {
    const {
        columns,
        class: userClass,
        style: userStyle,
        children,
        ...divProps
    } = props

    const baseStyle: JSX.CSSProperties = { '--columns': columns };
    const mergedStyle: string | JSX.CSSProperties =
        typeof userStyle === 'string'
            ? `${userStyle}; --columns: ${columns}`
            : { ...baseStyle, ...(userStyle ?? {}) }

    const mergedClass = [
        styles['st-grid-layout'],
        userClass
    ].filter(Boolean).join(' ')

    return (
        <div class={mergedClass} style={mergedStyle} {...divProps}>
            {children}
        </div>
    )
}

GridLayout.defaultProps = new GridLayoutProps();
